import isEmpty from "../helpers/isEmpty";
//---------------------
// calc combat actions
//---------------------
export default function calcCA(dex) {
  let ca = 0;
  if (isEmpty(dex)) {
    return 0;
  } else {
    switch (true) {
      case dex < 7:
        ca = 1;
        break;
      case dex > 6 && dex < 13:
        ca = 2;
        break;
      case dex > 12 && dex < 19:
        ca = 3;
        break;
      case dex > 18:
        ca = 4;
        break;
      default:
        ca = 0;
    }
    return ca;
  }
}
